import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';
import { mapAutoManufactureYears, mapAutoModels } from 'shared/lib/mapDictionaries';
import type { TAutoManufactureYear, TAutoModel, TAutoPower } from 'shared/types';

import { mapPowers } from '../lib/mapPowers';
import type { TPledgeAutoFormDictionaries } from '../types';

export const queries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getEnginePowers: build.query<
      TPledgeAutoFormDictionaries['powers'],
      { brandId: string | number; modelId: string | number; year: string | number }
    >({
      query: (params) => ({
        url: BFF_API_ROUTES.getCarEnginePowers,
        params,
      }),
      transformResponse: (response: TAutoPower[], _, args) => mapPowers(args, response),
    }),
    getModels: build.query<TPledgeAutoFormDictionaries['models'], number | string>({
      query: (brandId) => ({
        url: BFF_API_ROUTES.getAutoModels,
        params: { brandId },
      }),
      transformResponse: (response: TAutoModel[], _, brandId) => mapAutoModels({ brandId }, response),
    }),
    getManufactureYears: build.query<TPledgeAutoFormDictionaries['years'], number | string>({
      query: (modelId) => ({
        url: BFF_API_ROUTES.getCarManufactureYears,
        params: { modelId },
      }),
      transformResponse: (response: TAutoManufactureYear[], _, modelId) =>
        mapAutoManufactureYears({ modelId }, response),
    }),
  }),
});

export const useGetEnginePowers = queries.useLazyGetEnginePowersQuery;
export const useGetModels = queries.useLazyGetModelsQuery;
export const useGetManufactureYears = queries.useLazyGetManufactureYearsQuery;
